import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false }) => (
  <div className="flex items-center gap-3 mb-5">
    <span className="h-px w-10 bg-honey" />
    <span
      className={`text-xs md:text-sm uppercase tracking-[0.22em] font-bold ${
        dark ? "text-honey-light" : "text-honey"
      }`}
    >
      {children}
    </span>
  </div>
);
